export { __modelMeta__ } from './client/symbol.mjs';
//# sourceMappingURL=index.mjs.map
